export const types = {
  TEXTS: 'TEXTS',
  'TEXTS/LOADING': 'TEXTS/LOADING',
  'TEXTS/ERRORS': 'TEXTS/ERRORS',
  'TEXTS/SET_DATA': 'TEXTS/SET_DATA',
  'TEXTS/GET_DATA': 'TEXTS/GET_DATA'
}
